import img_one from "./img/image_one.webp";
import img_two from "./img/image_two.webp";
import img_three from "./img/image_three.webp";
import img_four from "./img/image_four.webp";

export const Data = [
  {
    title: "Sit amet",
    img: img_one,
    desc: "onsectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",
  },
  {
    title: "Suscipit mauri",
    img: img_two,
    desc: "Feugiat nibh sed pulvinar proin gravida hendrerit. Lorem donec massa sapien faucibus et molestie ac feugiat. ",
  },
  {
    title: "Purus volutpat ",
    img: img_three,
    desc: "Consequat mauris nunc. Lorem donec massa sapien faucibus et molestie ac feugiat sed",
  },
  {
    title: "Arcu bibenduml",
    img: img_four,
    desc: "Vitae nunc sed velit dignissim sodales ut eu sem. Nulla pellentesque dignissim enim sit. Arcu vitae elementum curabitur vitae nunc sed.",
  },
];
